<template>

  <div>

    <!-- AutoComplete Section -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <AutoComplete
          :search="fuzzySearch"
          placeholder="Search for categories"
          aria-label="Search for categories"
          @submit="updateSearchText"
        />
      </div>
    </div>

    <!-- Checkbox Section -->
    <div class="vx-row mt-6 mb-5">
      <div class="vx-col w-full">
        <vs-checkbox class="ml-0" color="#6DC5D0" v-model="isAllCategoriesChecked" @input="handleSelectAllClicked">{{ $t('Select All') }}</vs-checkbox>
      </div>
    </div>

    <!-- Tree Section -->
    <div class="vx-row pt-3 h-64 overflow-y-scroll treeContainer mx-0">
      <div class="vx-col w-full tree">
        <tree :data="[]" :filter="searchText" :options="tree.options" ref="tree" @node:unchecked="removeCategoryFromTree" @node:checked="addCategoryFromTree" />
      </div>
    </div>

  </div>
</template>


<script>

import AutoComplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  name: 'ContentCategories',
  data () {
    return {
      searchText: '',
      isAllCategoriesChecked: false,
      tree: {
        options: {
          checkbox: true
        }
      }
    }
  },

  props: {
    value: {
      type: Array
    },
    editing: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  computed: {
    contentCategoryCheckList () {
      return this.value || []
    },

    contentCategories () {
      return this.$store.getters['campaign/targetingLookups'].content_categories || []
    }
  },

  components: {
    AutoComplete
  },


  async mounted () {
    if (!this.contentCategories || this.contentCategories.length === 0) {
      await this.$store.dispatch('campaign/getTargetingLookups')
    }

    await this.setContentCategories()

    if (this.contentCategoryCheckList && !this.editing && this.contentCategoryCheckList.length === 0) {
      this.checkAllContentCategories()
    } else {
      this.markContentCategoriesCheckedByIds(this.contentCategoryCheckList)
    }
  },

  methods: {
    async getTreeContent () {
      return this.contentCategories.map((category) => {
        return {
          text: category.name,
          data: category,
          state: {
            checked: false
          }
        }
      })
    },

    async setContentCategories () {
      const treeContent = await this.getTreeContent()

      treeContent.forEach((node) => {
        this.$refs.tree.append(node)
      })
    },

    checkAllContentCategories () {
      this.contentCategories.forEach(category => this.addCategory(category, 3))
    },

    uncheckAllContentCategories () {
      this.contentCategories.forEach(category => this.removeCategory(category))
    },

    markContentCategoriesCheckedByIds (contentCategoriesIds = []) {
      this.contentCategories.forEach((category) => {
        if (contentCategoriesIds.indexOf(category.id) !== -1) {
          this.addCategory(category)
        }
      })
    },

    // Fuzzy search content categories
    fuzzySearch (searchText) {
      this.updateSearchText(searchText)
      if (searchText.length < 1) { return [] }
      return this.contentCategories.filter(category => {
        return category.name.toLowerCase()
          .startsWith(searchText.toLowerCase())
      }).map(category => category.name)
    },

    updateSearchText (searchText) {
      this.searchText = searchText
    },

    // Handle Events //
    async handleSelectAllClicked () {
      if (this.isAllCategoriesChecked) {
        this.checkAllContentCategories()
      } else {
        this.uncheckAllContentCategories()
      }
    },

    removeCategoryFromTree (node) {
      this.removeCategory(node.data)
      this.isAllCategoriesChecked = false
    },

    addCategoryFromTree (node) {
      this.addCategory(node.data)
      this.isAllCategoriesChecked = this.isAllTreeNodesChecked()
    },

    removeCategory (category) {
      const valueIndex = this.contentCategoryCheckList.findIndex(i => i === category.id)
      if (valueIndex !== -1) {
        this.contentCategoryCheckList.splice(valueIndex, 1)
      }
      this.$refs.tree.find(category.name)[0].uncheck()
    },

    isAllTreeNodesChecked () {
      return this.$refs.tree.tree.checkedNodes.length === this.$refs.tree.tree.model.length
    },

    addCategory (category, trail = 0) {
      const valueIndex = this.contentCategoryCheckList.findIndex(i => i === category.id)
      if (valueIndex === -1) {
        this.contentCategoryCheckList.push(category.id)
      }
      const result = this.$refs.tree.find(category.name)
      if (result[0]) {
        result[0].check()
      } else if (trail > 0) {
        this.addCategory(category, trail--)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .tree {
    padding-left: 0 !important;
  }
</style>
